import { Box, BoxProps } from '@chakra-ui/react';
import { ISidebarItem } from 'types/layout/ISidebarItem';
import SidebarContent, { SidebarContentProps } from './SidebarContent';

type SidebarProps = BoxProps & {
  items: ISidebarItem[];
  contentProps?: Omit<SidebarContentProps, 'items'>;
};

const Sidebar = ({ items, contentProps, ...props }: SidebarProps) => (
  <Box {...props} data-testid="sidebar">
    <SidebarContent items={items} {...contentProps} />
  </Box>
);

export default Sidebar;
